import axios from "axios";


const BASE_URL = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/zones`,
});


const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// 📖 Get all zones for an org


export async function getZonesByOrg(orgId) {
  try {
    const res = await BASE_URL.get(`/${orgId}/zones`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 📖 Get single zone

export async function getZone(zoneId) {
  try {
    const res = await BASE_URL.get(`/zones/${zoneId}`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}


// ➕ Create zone under org


export async function createZone(orgId, zoneData) {
  const payload = { ...zoneData, orgId };
  try {
    const res = await BASE_URL.post(`/${orgId}/zones`, payload, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update zone


export async function updateZone(zoneId, updates) {
  try {
    const res = await BASE_URL.put(`/zones/${zoneId}`, updates, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete zone

export async function deleteZone(zoneId) {
  try {
    const res = await BASE_URL.delete(`/zones/${zoneId}`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}